import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "screen-reader" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "about-page content"
}
const _hoisted_6 = { class: "about-page__content" }
const _hoisted_7 = {
  class: "ps__wrapper",
  ref: "wrapperScrollbar"
}
const _hoisted_8 = {
  key: 1,
  class: "credits-page content"
}
const _hoisted_9 = { class: "credits-page__content" }
const _hoisted_10 = {
  class: "ps__wrapper",
  ref: "wrapperScrollbar"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoMain = _resolveComponent("LogoMain")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["modal about-credit-modal", { 'from-bus-event': _ctx.fromBus }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.fromBus == false)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                role: "button",
                class: "close",
                title: _ctx.btnCloseTitle,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
              }, [
                _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
                  [_directive_translate, `general.modal_close`]
                ])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.section == 'about')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_LogoMain),
                    _withDirectives(_createElementVNode("h2", null, null, 512), [
                      [_directive_translate, `about.about_subtitle`]
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_perfect_scrollbar, { ref: "scrollbar" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, null, 512), [
                            [_directive_translate, `about.text_about`]
                          ])
                        ]),
                        _: 1
                      }, 512)
                    ], 512)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.section == 'credits')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_LogoMain),
                    _withDirectives(_createElementVNode("h2", null, null, 512), [
                      [_directive_translate, `about.credits`]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_perfect_scrollbar, { ref: "scrollbar" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.credits, (paragraph, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              innerHTML: _ctx.showParagraph(paragraph),
                              class: _normalizeClass(["paragraph-group group",  index === (_ctx.credits.length - 1) ? 'last-group' : 'not-last-group' ])
                            }, null, 10, _hoisted_11))
                          }), 128))
                        ]),
                        _: 1
                      }, 512)
                    ], 512)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2), [
        [_vShow, _ctx.display]
      ])
    ]),
    _: 1
  }))
}